import { createHbmlHeadersNodeComponents } from "./common/createHbmlHeadersNodeComponents";

export const HbmlHeaders2Node = createHbmlHeadersNodeComponents(2);
